import { useQuery, QueryFunction } from 'react-query';
import { getCoordsFromAddress, Coordinates } from '../../services/geocoding';

type UseGeocodeQueryOptions = {
    address: string;
    minScore?: number;
};

const getCoordinatesQuery: QueryFunction<Coordinates | null> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseGeocodeQueryOptions];
    const { address, minScore } = options;

    return await getCoordsFromAddress(address, minScore);
};

export const useGeocodeQuery = (options: UseGeocodeQueryOptions) => {
    return useQuery(['geocode', options], getCoordinatesQuery, {
        enabled: !!options.address && options.address.trim() !== '',
    });
};
